// WebSocketService.js
class WebSocketService {
  static instance = null;
  socket = null;

  static getInstance() {
    if (!WebSocketService.instance) {
      WebSocketService.instance = new WebSocketService();
    }
    return WebSocketService.instance;
  }

  connect(url) {
    if (!this.socket || this.socket.readyState === WebSocket.CLOSED) {
      this.socket = new WebSocket(url);

      this.socket.onopen = () => {
        console.log("WebSocket connected!");
      };

      this.socket.onclose = () => {
        console.log("WebSocket closed!");
      };

      this.socket.onerror = (err) => {
        console.error("WebSocket error:", err);
      };
    }

    return this.socket;
  }

  getSocket() {
    return this.socket;
  }

  close() {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.close();
      this.socket = null;
      console.log("WebSocket manually closed");
    }
  }
}

export default WebSocketService;
